import { ThumbnailPhotoCard } from '@peacecover/component';
import { CheckCircleFill } from '@peacecover/icon';

interface PhotoCardCheckBoxProps {
  imageUrl: string;
  artistName: string;
  categoryName: string;
  categoryEmoji?: string | null;
  eventName?: string | null;
  price?: string | null;
  icon?: React.ReactNode;
  isChecked?: boolean;
  onChange?: (checked: boolean) => void;
}

const PhotoCardCheckBox = ({
  imageUrl,
  artistName,
  categoryName,
  categoryEmoji,
  eventName,
  price,
  icon,
  isChecked,
  onChange
}: PhotoCardCheckBoxProps) => {
  return (
    <div className="relative flex flex-col gap-[10px] w-[158px]">
      <div
        className="px-[48px] py-[29px] bg-[#f4f4f4] dark:bg-separator1 rounded-[12px]"
        onClick={(e) => {
          if (!(e.target as Element).closest('[data-button-toggle]')) {
            onChange?.(!isChecked);
          }
        }}
      >
        <div className="drop-shadow-[0px_0px_15px_rgba(0,0,0,0.10)]">
          <ThumbnailPhotoCard imageUrl={imageUrl} className="w-[63px] h-[100px]" />
        </div>
        <button
          type="button"
          className="absolute top-[5px] right-[5px]"
          onClick={(e) => {
            e.stopPropagation();
            onChange?.(!isChecked);
          }}
        >
          <CheckCircleFill
            size={24}
            backgroundColor={isChecked ? 'var(--color-primary)' : 'var(--color-surface-lv2)'}
            strokeColor={isChecked ? 'var(--color-on-primary)' : 'var(--color-on-disable)'}
          />
        </button>
      </div>
      <div className="flex flex-col gap-[6px]">
        <p className="text-[14px] font-medium text-text-main-lv1 h-[17px] truncate">
          {artistName}의 {categoryName}
          {categoryEmoji}
        </p>
        {eventName && (
          <p className="text-[13px] leading-none py-[2px] font-medium text-text-main-lv3 truncate">
            {eventName}
          </p>
        )}
        {price && (
          <div className="flex flex-row items-center gap-[4px] h-[17px]">
            <p className="text-[14px] font-medium text-text-primary leading-none truncate">
              {price}
            </p>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoCardCheckBox;
